<template>
  <Modal v-model="isShowModal" fullscreen footer-hide>
    <div class="plan-record-modal-root-container" v-if="isShowModal">
      <div class="page-title">发送记录</div>

      <slider-tabbar
        style="margin-top: 15px"
        :tabs="tabs"
        @on-change="onBarChange"
      ></slider-tabbar>

      <div class="plan-record-modal-list-container">
        <plan-item
          v-for="item in plan_list"
          :key="item.pay_plan_id"
          :can-show-modal="true"
          :data-source="item"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import PlanItem from "../Item/PlanItem";
import SlideTabbar from "../../../components/SlideTabbar";
import { mapActions } from "vuex";
export default {
  components: {
    "plan-item": PlanItem,
    "slider-tabbar": SlideTabbar,
  },
  data() {
    return {
      isShowModal: false,

      currentIndex: 0,
      tabs: [
        {
          name: "等待支付的",
        },
        {
          name: "已被支付的",
        },
      ],
      plan_list: [],
    };
  },
  methods: {
    ...mapActions({
      planGetListAction: "planGetList",
    }),
    open() {
      this.isShowModal = true;

      this.getList(2);
    },
    onBarChange(index) {
      this.currentIndex = index;

      this.getList(this.currentIndex + 2);
    },
    getList(state) {
      this.plan_list = [];
      this.planGetListAction({
        employer_id: localStorage.getItem("employer_id"),
        state: state,
        orderby_type: 1,
      })
        .then((res) => {
          for (let item of res) {
            item.isValid = true;
          }

          this.plan_list = res;
        })
        .catch((error) => {
          this.$Message.error(error);
        });
    },
  },
};
</script>

<style scoped>
.plan-record-modal-root-container {
  display: flex;
  flex-direction: column;
  padding-top: 100px;
  padding-left: 285px;
  padding-right: 150px;
}
.plan-record-modal-list-container {
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
}
</style>